export interface IFilterOptions {
    filter?: Record<string, unknown>;
    limit?: number;
    page?: number;
    sort?: string;
    populate?: string;
    select?: string;
    autoPopulate?: boolean;
    includeDeleted?: boolean;
    cache?: boolean;
}
